<template>
  <div class="card position-sticky top-1 mt-4">
    <ul class="nav flex-column bg-white border-radius-lg p-3">
      <li v-for="item in sections" :key="item.id" class="nav-item" :class="{ 'pt-2': itemSpacing }">
        <a class="nav-link text-dark d-flex" data-scroll :href="`#${item.id}`">
          <i class="material-icons text-lg me-2">{{ item.icon }}</i>
          <span class="text-sm">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SideNav",
  props: {
    sections: {
      type: Array,
      default: () => ([
        { id: 'basic-info', icon: 'receipt_long', label: '기본 정보' },
        { id: 'password', icon: 'lock', label: '비밀번호 변경' },
        { id: 'account-status', icon: 'verified_user', label: '계정 상태' },
      ])
    },
    itemSpacing: {
      type: Boolean,
      default: true
    }
  }
};
</script>
